import { shipmentApiClient } from '../shipmentApiClient'
import { getShipmentEndpoint } from './endpoint'
import type { GetShipmentParams, GetShipmentResponse } from './type'

export const getShipment = async (params: GetShipmentParams): Promise<GetShipmentResponse> => {
  const { data } = await shipmentApiClient.get<GetShipmentResponse>(
    getShipmentEndpoint(params.shipmentUid),
    { params: { deliveryReportUid: params.deliveryReportUid } }
  )
  return data
}
